import type { ProductSwitcherItem } from '@deque/ui-navbar';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { AxeProductVisionWebinarBanner } from '~/common/components/AxeProductVisionWebinarBanner';
import Header from '~/common/components/Header';
import MainLayout from '~/common/components/MainLayout';
import { useFeatureFlagState } from '~/common/contexts/featureFlags';
import AnnouncementToasts from './announcements/AnnouncementToasts';
import AppNavBar from './AppNavBar';

interface Props {
  children: React.ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  const hasProductsV2 = useFeatureFlagState('products_v2');
  const announcementsEnabled = useFeatureFlagState(
    'in_product_announcements_v1'
  );

  const isInvoice = !!useRouteMatch({
    path: '/billing/invoices/'
  });
  const isIssueSharing = !!useRouteMatch({
    path: '/issues/'
  });
  const isAcceptingInvitation = !!useRouteMatch({
    path: '/accept-invitation'
  });
  const isSigningUp = !!useRouteMatch({
    path: '/signup'
  });
  const shouldShowHeader = !isInvoice;
  const shouldShowFooter = !isInvoice;
  const hasBottomNav =
    shouldShowHeader &&
    !(isIssueSharing || isAcceptingInvitation) &&
    !(isSigningUp && hasProductsV2);

  const currentProduct: ProductSwitcherItem = {
    name: 'Axe Account',
    url: '/',
    slug: 'axe-account'
  };

  const navBar = hasBottomNav ? <AppNavBar /> : null;

  const header = shouldShowHeader ? (
    <Header navBar={navBar} currentProduct={currentProduct} />
  ) : null;

  return (
    <MainLayout
      header={header}
      hasBottomNav={hasBottomNav}
      shouldShowFooter={shouldShowFooter}
      promotionalBanner={
        // Rendered in the top banner region (above the page content). Announcements
        // come first so an active announcement takes the top banner slot.
        <>
          {announcementsEnabled && (
            <AnnouncementToasts productSlug="axe-account" />
          )}
          <AxeProductVisionWebinarBanner />
        </>
      }
    >
      {children}
    </MainLayout>
  );
};

export default Layout;
